import styled from "styled-components";
import Heading1 from "./Heading1";

const Heading1LnlnOffice = styled(Heading1)`
  background-color: ${(p) => p.theme.lnlnOffice.darkBlue1};
`;

export default Heading1LnlnOffice;
